import { useMutation } from "@tanstack/react-query";
import client from "@/data/client";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";
import { DefaultErrorResponse } from "@/types";

export function useUpdateAvailabilityMutation() {
  return useMutation(client.availability.update, {
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}
